import { addDoc, updateDoc, doc, collection, increment, serverTimestamp } from "firebase/firestore";
import { db } from "./config.js";

export default async function uploadSaga({ saga }) {
  if (typeof saga !== "string" || saga.length < 10) {
    return {
      success: false,
      error: "invalid message"
    };
  }

  try {
    await addDoc(collection(db, "sagas"), {
      saga: saga.trim().replaceAll("\n", "<br>"),
      timestamp: serverTimestamp(),
      posted: false
    });
  
    await updateDoc(doc(db, "app", "infos"), {
      sagaCount: increment(1)
    });
  
    return {
      success: true
    }
  }
  catch (error) {
    return {
      success: false,
      error
    }
  }
}